import React from "react";
import { ButtonOval } from "./ButtonOval";

export const DetailsMesures = ({ heightPokemon, weigthPokemon }) => {
  const heightP = heightPokemon / 10;
  const weigthP = weigthPokemon / 10;
  return (
    <div className="details">
      <h2 className="height-poke">📏 Height</h2>
      <h2 className="weight-poke">⚖️ weight</h2>
      <ButtonOval elementName={heightP ? `${heightP}M` : "?"} />
      <ButtonOval elementName={weigthP ? `${weigthP} K` : "?"} />
    </div>
  );
};

export default DetailsMesures;
